<label for="feature_{{feature.id}}">
  {{ feature.header }}@if (feature.unitHeader) {
  <span>, {{ feature.unitHeader }}</span>
}
@if (isRequired()) {
  <span> *</span>
}
@if (feature.comment) {
  <span nbTooltip="{{feature.comment}}"><tui-icon icon="lightbulb"/></span>
}
</label>

<div class="accordion-item__right">
  <form [formGroup]="form">
    <div formArrayName="items">
      @for (itemForm of items.controls; track itemForm; let i = $index) {
        <div>
          <div [formGroup]="itemForm" class="smartlistItem mb-2">
            <input nbInput
              class="me-2"
              fieldSize="small"
              placeholder="Название параметра"
              i18n-placeholder="@@SmartlistKeyPlaceholder"
              formControlName="key"
              />
            <input nbInput
              class="me-2"
              fieldSize="small"
              placeholder="Значение параметра"
              i18n-placeholder="@@SmartlistValuePlaceholder"
              formControlName="value"
              />
            <button type="button" (click)="deleteSmartlistItem(i)" nbButton size="small" status="control">
              <tui-icon icon="x"/>
            </button>
          </div>
        </div>
      }
    </div>

    <div>
      <button type="button" (click)="addSmartlistItem()" nbButton size="small" status="control" i18n="@@AddSmartlistItem">
        <tui-icon icon="square-plus" />
        Добавить
      </button>
    </div>
  </form>
  <div class="accordion-item__right-info">
    @if (feature.fromMasterCard) {
      <div class="state-master-card" i18n-nbTooltip="@@FeatureFromMasterCard" nbTooltip="Характеристика заполнена из мастер карты">
        <tui-icon icon="credit-card"/>
      </div>
    }
    @if (form.valid && isShowEmptyWarning()) {
      <div class="state-warn">
        <tui-icon icon="triangle-alert"/>
      </div>
    }
    @if (form.invalid) {
      <div class="state-err">
        <tui-icon icon="circle-alert"/>
      </div>
    }
    @if (form.valid && !isEmpty()) {
      <div class="state-success">
        <tui-icon icon="check"/>
      </div>
    }

    @if (featureLink) {
      <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
        class="entityID"
        target="_blank"
        i18n-nbTooltip="@@OpenFeatureInNewWindow"
        nbTooltip="Открыть характеристику в новом окне"
        >
        #{{ feature.featureId }}
      </a>
    }
    @if (showRemoveButton) {
      <button nbButton ghost size="tiny" status="danger" (click)="removeEvent.emit()" nbTooltip="Удалить характеристику МК" i18n-nbTooltip="@@DeleteMasterCardFeature">
        <tui-icon icon="trash-2"/>
      </button>
    }
  </div>
</div>
